import MyRoutes from "./routers";

function App() {
  return <MyRoutes />;
}

export default App;
